import * as React from 'react';
import { List } from '@material-ui/core';
import { contact } from '../../../model/contact';
import { User } from './User';

type UnreadCount = {
    [key: string]: { count: number, date: Date }
}

interface IProps {
    contactList: Array<contact>,
    onContactClick: (sub: string) => void,
    getChatMessages: (sub: string) => void
    setSelectedUser: (sub: string) => void;
    goToContact:(sub: string) => void;
    current: string;
    unreadcount: UnreadCount;
}
interface IState {
    orderedContacts: Array<contact>
}


const sort = (unreadcount: UnreadCount) => (a: contact, b: contact) => {
    try {
        const aC = { ...unreadcount[a.sub] };
        const bC = { ...unreadcount[b.sub] };

        if (aC === undefined || aC.date === undefined || typeof aC.date.getTime !== 'function')
            return +1;
        else if (bC === undefined || bC.date === undefined || typeof bC.date.getTime !== 'function')
            return -1;
        else {
            return -(aC.date.getTime() - bC.date.getTime());
        }
    } catch (ex) {
        console.error(ex);
        return 0;
    }
}
export class Users extends React.Component<IProps, IState>{
    // state = {
    //     orderedContacts: []
    // }

    // componentDidUpdate(precProps: IProps) {
    //     if (precProps.contactList !== this.props.contactList || precProps.unreadcount !== this.props.unreadcount || precProps.contactList.length !== this.props.contactList.length) {
    //         console.info('reordering contacts');
    //         let cS = [...this.props.contactList].sort(sort(this.props.unreadcount));
    //         this.setState({ orderedContacts: cS });
    //     }
    // }

    public render() {
        let cS = [...this.props.contactList].sort(sort(this.props.unreadcount));
        return (
            <List>
                {cS.map(c =>
                    <User
                        unreadcount={this.props.unreadcount[c.sub] ? this.props.unreadcount[c.sub].count : 0}
                        isSelected={c.sub === this.props.current}
                        contact={c}
                        key={c.sub}
                        onContactClick={this.props.onContactClick}
                        setSelectedUser={this.props.setSelectedUser}
                        getChatMessages={this.props.getChatMessages}
                        goToContact={this.props.goToContact}
                    />)}
            </List>
        );
    }
}